<template>
  <div class="wxts">
    <div class="t" @click="onshow">
      <div class="icon">
        <img src="../assets/img/icon_wxts.png">
      </div>
      <div :class="[isshow == false ? 'word' : 'words']">温馨提示</div>
    </div>
    <div class="b" v-show="isshow">
      <p v-for="(i, c) in wxtsList" :key="c">
        <span v-if="i.path&&!i.path2">
          {{ i.name }}<router-link :to="i.path">{{ i.pathName }}</router-link>{{ i.tailName }}
        </span>
        <span v-if="i.path&&i.path2">
          {{ i.name }}<router-link :to="i.path">{{ i.pathName }}</router-link>{{ i.midName }}<router-link :to="i.path2">{{ i.path2Name }}</router-link>{{ i.tailName }}
        </span>
        <span v-if="!i.path">{{ i.name }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Wxts",
  props: {
    wxtsList: Array,
  },
  data() {
    return {
      isshow: false,
    };
  },
  methods: {
    onshow() {
      this.isshow = !this.isshow;
    },
    onAdd() {
      this.$emit("onAdd");
    }
  }
};
</script>

<style lang="less" scoped>
.wxts {
  z-index: 999;
  // position: relative;
  // width: 50%;
  // text-align: right;

  .t {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    // width: 500px;

    .icon {
      width: 12px;
      height: 12px;
      padding-right: 5px
    }

    .word {
      font-weight: 400;
      font-size: 13px;
      color: #909399;
    }

    .words {
      font-weight: 400;
      font-size: 13px;
      color: #2691FF;
    }
  }

  .b {
    position: absolute;
    top: 122px;
    right: 40px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.12);
    border-radius: 5px 5px 5px 5px;
    padding: 10px;
    font-size: 13px;
    color: #909399;
    p{
      margin-bottom: 3px;
    }
  }
}
</style>
